import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { legacyLangRedirect } from './seo/site';
import { startAnalytics } from './analytics/analytics';

// Old links used "/?lang=xx". nginx answers those with a 301; this is the
// fallback for servers that don't (e.g. the dev server).
const legacy = legacyLangRedirect(window.location.pathname, window.location.search, window.location.hash);

if (legacy) {
  window.location.replace(legacy);
} else {
  // GA4 — does nothing until the visitor accepts cookies (src/analytics/).
  startAnalytics();

  const container = document.getElementById("root");
  const app = <App />;
  // Public pages ship prerendered HTML (scripts/prerender.js): hydrate it.
  // The admin shell (spa.html) has an empty root and renders from scratch.
  if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, app);
  } else {
    ReactDOM.createRoot(container).render(app);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
